export default function Redirect(params) {
  window.location.replace('https://donate.givemasjid.com/' + params.destination); 

  return (
    <div />

  )
}
